import API from "./lib/api";
import { giftCardUrl } from "./lib/url";


export const getAllGiftCardApi = async (restaurant_id, query) => {
    try {
        const { data } = await API.get(
            `restaurant/${restaurant_id}${giftCardUrl}?${query}`
        );

        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}



export const addGiftCardApi = async (giftCardData) => {
    try {
        
        const response = await API.post( 
            `restaurant${giftCardUrl}`,
            giftCardData
        );

        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}

export const singleGiftCardApi = async (id) => {
    try {
        
        const { data } = await API.get( 
            `restaurant${giftCardUrl}/${id}`
        );

        return data;
    } catch (error) {
        return error.response.data;
    }
}

export const editGiftCardApi = async (giftCardData, id) => {
    try {
        
        const { data } = await API.put( 
            `restaurant${giftCardUrl}/${id}`,
            giftCardData
        );

        return data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}


export const deleteGiftCardApi = async (id) => {
    try {
        
        const response = await API.delete(`restaurant/gift-cards/${id}`);

        return response.data;
    } catch (error) {
        return (
            error.response?.data || {
                status: "failure",
                message: "Something went wrong.",
            }
        );
    }
}